import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "./../_helpers";

// create slice

const name = "master";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = (builder) => {
  createExtraReducers(builder);
};
const slice = createSlice({ name, initialState, extraReducers });

// exports
export const masterActions = { ...slice.actions, ...extraActions };
export const masterReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    stateDrpList: [],
    userTypeDrpList: [],
    warehouseDrpList: [],
    countryDrpList: [],
    categoryDrpList: [],
    subCategoryDrpList: [],
    clientTypeDrpList: [],
    clientQuotaDrpList: [],
    attributeDrpList: [],
    vendorDrpList: [],
    stockStatusDrpList: [],
    shippingMethodDrpList: [],
    termDrpList: [],
    packageTypeDrpList: [],
    clientDrpList: [],
    orderSourceDrpList: [],
    productDrpList: [],
    productDetailDrpList: [],
    transactionTypeDrpList: [],
    orderStatusDrpList: [],
    paymentTypeDrpList: [],
    courierTypeDrpList: [],
    boxNumberDrpList: [],
  };
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/Master`;
  return {
    GetUserTypeList: GetUserTypeList(),
    GetStateList: GetStateList(),
    GetCountryList: GetCountryList(),
    GetWarehouseList: GetWarehouseList(),
    GetCategoryDrpList: GetCategoryDrpList(),
    GetSubCategoryDrpList: GetSubCategoryDrpList(),
    GetClientTypeDrpList: GetClientTypeDrpList(),
    GetClientQuotaDrpList: GetClientQuotaDrpList(),
    GetAttributeDrpList: GetAttributeDrpList(),
    GetvendorDrpList: GetvendorDrpList(),
    GetstockStatusDrpList: GetstockStatusDrpList(),
    GetshippingMethodDrpList: GetshippingMethodDrpList(),
    GetTermDrpList: GetTermDrpList(),
    GetPackageTypeDrpList: GetPackageTypeDrpList(),
    GetClientDrpList: GetClientDrpList(),
    GetOrderSourceList: GetOrderSourceList(),
    GetProductDrpList: GetProductDrpList(),
    GetOrderProductDrpList: GetOrderProductDrpList(),
    GetTransactionTypeDrpList: GetTransactionTypeDrpList(),
    GetOrderStatusDrpList: GetOrderStatusDrpList(),
    GetPaymentTypeDrpList: GetPaymentTypeDrpList(),
    GetCourierTypeDrpList: GetCourierTypeDrpList(),
    GetBoxNumberDrpList: GetBoxNumberDrpList(),
  };

  function GetUserTypeList() {
    return createAsyncThunk(
      `${name}/GetUserTypeList`,
      async () => await fetchWrapper.get(`${baseUrl}/GetUserType`)
      // async () => await MasterService.GetUserTypeList()
    );
  }

  function GetWarehouseList() {
    return createAsyncThunk(
      `${name}/GetWarehouseList`,
      async ({ WareHouseID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetWarehouse?WareHouseID=${WareHouseID}&Status=${Status}`
        )
      // async () => await MasterService.GetWarehouseList()
    );
  }
  function GetStateList() {
    return createAsyncThunk(
      `${name}/GetState`,
      async () => await fetchWrapper.get(`${baseUrl}/GetState`)
      // async () => await MasterService.GetStateList()
    );
  }
  function GetCountryList() {
    return createAsyncThunk(
      `${name}/GetCountry`,
      async () => await fetchWrapper.get(`${baseUrl}/GetCountry`)
      // async () => await MasterService.GetCountryList()
    );
  }
  function GetCategoryDrpList() {
    return createAsyncThunk(
      `${name}/GetCategoryDrpList`,
      async ({ CategoryID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetCategory?CategoryID=${CategoryID}&Status=${Status}`
        )
      // async () => await MasterService.GetCountryList()
    );
  }

  function GetSubCategoryDrpList() {
    return createAsyncThunk(
      `${name}/GetSubCategoryDrpList`,
      async ({ CategoryID, SubCategoryID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetSubCategoryDrpList?CategoryID=${CategoryID}&SubCategoryID=${SubCategoryID}&Status=${Status}`
        )
    );
  }
  function GetAttributeDrpList() {
    return createAsyncThunk(
      `${name}/GetAttributeDrpList`,
      async ({ AttributeID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetAttribute?AttributeID=${AttributeID}&Status=${Status}`
        )
    );
  }

  function GetClientTypeDrpList() {
    return createAsyncThunk(
      `${name}/GetClientTypeDrpList`,
      async () => await fetchWrapper.get(`${baseUrl}/GetClientType`)
      // async () => await MasterService.GetCountryList()
    );
  }
  function GetClientQuotaDrpList() {
    return createAsyncThunk(
      `${name}/GetClientQuotaDrpList`,
      async () => await fetchWrapper.get(`${baseUrl}/GetClientQuota`)
      // async () => await MasterService.GetCountryList()
    );
  }

  function GetvendorDrpList() {
    return createAsyncThunk(
      `${name}/GetvendorDrpList`,
      async ({ VendorID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetVendor?VendorID=${VendorID}&Status=${Status}`
        )
      // async () => await MasterService.GetCountryList()
    );
  }
  function GetstockStatusDrpList() {
    return createAsyncThunk(
      `${name}/GetstockStatusDrpList`,
      async () => await fetchWrapper.get(`${baseUrl}/GetStockStatus`)
    );
  }
  function GetshippingMethodDrpList() {
    return createAsyncThunk(
      `${name}/GetshippingMethodDrpList`,
      async () => await fetchWrapper.get(`${baseUrl}/GetShippingMethod`)
    );
  }
  function GetTermDrpList() {
    return createAsyncThunk(
      `${name}/GetTermsDrpList`,
      async ({ AttributeID, TermID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetTermDrpList?AttributeID=${AttributeID}&TermID=${TermID}&Status=${Status}`
        )
    );
  }
  function GetPackageTypeDrpList() {
    return createAsyncThunk(
      `${name}/GetPackageTypeDrpList`,
      async () => await fetchWrapper.get(`${baseUrl}/GetPackageType`)
    );
  }
  function GetClientDrpList() {
    return createAsyncThunk(
      `${name}/GetClientDrpList`,
      async ({ ClientID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetClient?ClientID=${ClientID}&Status=${Status}`
        )
    );
  }
  function GetOrderSourceList() {
    return createAsyncThunk(
      `${name}/GetOrderSourceList`,
      async () => await fetchWrapper.get(`${baseUrl}/GetOrderSourceList`)
    );
  }
  function GetProductDrpList() {
    return createAsyncThunk(
      `${name}/GetProductDrpList`,
      async () => await fetchWrapper.get(`${baseUrl}/GetProductList`)
    );
  }

  function GetOrderProductDrpList() {
    return createAsyncThunk(
      `${name}/GetOrderProductDrpList`,
      async ({ ProductID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetProductDetailDrpList?ProductID=${ProductID}&Status=${Status}`
        )
    );
  }

  function GetTransactionTypeDrpList() {
    return createAsyncThunk(
      `${name}/GetTransactionTypeDrpList`,
      async ({ TransactionTypeID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetTransactionType?TransactionTypeID=${TransactionTypeID}&Status=${Status}`
        )
    );
  }
  function GetOrderStatusDrpList() {
    return createAsyncThunk(
      `${name}/GetOrderStatusDrpList`,
      async ({ OrderStatusID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetOrderStatus?OrderStatusID=${OrderStatusID}&Status=${Status}`
        )
    );
  }
  function GetPaymentTypeDrpList() {
    return createAsyncThunk(
      `${name}/GetPaymentTypeDrpList`,
      async ({ PaymentTypeID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetPaymentType?PaymentTypeID=${PaymentTypeID}&Status=${Status}`
        )
    );
  }
  function GetCourierTypeDrpList() {
    return createAsyncThunk(
      `${name}/GetCourierTypeDrpList`,
      async ({ CourierTypeID, Status }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetCourierType?CourierTypeID=${CourierTypeID}&Status=${Status}`
        )
    );
  }
  function GetBoxNumberDrpList() {
    return createAsyncThunk(
      `${name}/GetBoxNumber`,
      async ({ OrderID }) =>
        await fetchWrapper.get(`${baseUrl}/GetBoxNumber?OrderID=${OrderID}`)
    );
  }
}

function createExtraReducers(builder) {
  builder
    // User Type List
    .addCase(extraActions.GetUserTypeList.pending, (state) => {
      state.userTypeDrpList = { loading: true };
    })
    .addCase(extraActions.GetUserTypeList.fulfilled, (state, action) => {
      let currentUser = JSON.parse(localStorage.getItem("user"));
      let dataList = action.payload;

      if (currentUser.UserTypeID === 2) {
        dataList =
          dataList &&
          dataList.filter((d) => d.value !== currentUser.UserTypeID);
      }

      state.userTypeDrpList = dataList;
    })
    .addCase(extraActions.GetUserTypeList.rejected, (state, action) => {
      state.userTypeDrpList = { error: action.error };
    })

    // Warehouse List
    .addCase(extraActions.GetWarehouseList.pending, (state) => {
      state.warehouseDrpList = { loading: true };
    })
    .addCase(extraActions.GetWarehouseList.fulfilled, (state, action) => {
      state.warehouseDrpList = action.payload;
    })
    .addCase(extraActions.GetWarehouseList.rejected, (state, action) => {
      state.warehouseDrpList = { error: action.error };
    })

    // State List
    .addCase(extraActions.GetStateList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetStateList.fulfilled, (state, action) => {
      state.stateDrpList = action.payload;
    })
    .addCase(extraActions.GetStateList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // Country List
    .addCase(extraActions.GetCountryList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetCountryList.fulfilled, (state, action) => {
      state.countryDrpList = action.payload;
    })
    .addCase(extraActions.GetCountryList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // Category List
    .addCase(extraActions.GetCategoryDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetCategoryDrpList.fulfilled, (state, action) => {
      state.categoryDrpList = action.payload;
    })
    .addCase(extraActions.GetCategoryDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // SubCategory List
    .addCase(extraActions.GetSubCategoryDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetSubCategoryDrpList.fulfilled, (state, action) => {
      state.subCategoryDrpList = action.payload;
    })
    .addCase(extraActions.GetSubCategoryDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // Repeat for all other dropdown lists
    .addCase(extraActions.GetClientTypeDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetClientTypeDrpList.fulfilled, (state, action) => {
      state.clientTypeDrpList = action.payload;
    })
    .addCase(extraActions.GetClientTypeDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    .addCase(extraActions.GetClientQuotaDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetClientQuotaDrpList.fulfilled, (state, action) => {
      state.clientQuotaDrpList = action.payload;
    })
    .addCase(extraActions.GetClientQuotaDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    .addCase(extraActions.GetAttributeDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetAttributeDrpList.fulfilled, (state, action) => {
      state.attributeDrpList = action.payload;
    })
    .addCase(extraActions.GetAttributeDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    .addCase(extraActions.GetvendorDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetvendorDrpList.fulfilled, (state, action) => {
      state.vendorDrpList = action.payload;
    })
    .addCase(extraActions.GetvendorDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    .addCase(extraActions.GetstockStatusDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetstockStatusDrpList.fulfilled, (state, action) => {
      state.stockStatusDrpList = action.payload;
    })
    .addCase(extraActions.GetstockStatusDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    .addCase(extraActions.GetshippingMethodDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(
      extraActions.GetshippingMethodDrpList.fulfilled,
      (state, action) => {
        state.shippingMethodDrpList = action.payload;
      }
    )
    .addCase(
      extraActions.GetshippingMethodDrpList.rejected,
      (state, action) => {
        state.error = { error: action.error };
      }
    )

    .addCase(extraActions.GetTermDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetTermDrpList.fulfilled, (state, action) => {
      state.termDrpList = action.payload;
    })
    .addCase(extraActions.GetTermDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    .addCase(extraActions.GetPackageTypeDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetPackageTypeDrpList.fulfilled, (state, action) => {
      state.packageTypeDrpList = action.payload;
    })
    .addCase(extraActions.GetPackageTypeDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })
    .addCase(extraActions.GetClientDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetClientDrpList.fulfilled, (state, action) => {
      state.clientDrpList = action.payload;
    })
    .addCase(extraActions.GetClientDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // Order Source List
    .addCase(extraActions.GetOrderSourceList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetOrderSourceList.fulfilled, (state, action) => {
      state.orderSourceDrpList = action.payload;
    })
    .addCase(extraActions.GetOrderSourceList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // Product List
    .addCase(extraActions.GetProductDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetProductDrpList.fulfilled, (state, action) => {
      state.productDrpList = action.payload;
    })
    .addCase(extraActions.GetProductDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // Order Product List
    .addCase(extraActions.GetOrderProductDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetOrderProductDrpList.fulfilled, (state, action) => {
      state.productDetailDrpList = action.payload;
    })
    .addCase(extraActions.GetOrderProductDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // Transaction Type List
    .addCase(extraActions.GetTransactionTypeDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(
      extraActions.GetTransactionTypeDrpList.fulfilled,
      (state, action) => {
        state.transactionTypeDrpList = action.payload;
      }
    )
    .addCase(
      extraActions.GetTransactionTypeDrpList.rejected,
      (state, action) => {
        state.error = { error: action.error };
      }
    )

    // Order Status List
    .addCase(extraActions.GetOrderStatusDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetOrderStatusDrpList.fulfilled, (state, action) => {
      let dataList = action.payload;
      dataList = dataList && dataList.filter((d) => d.value !== 1); // Example condition
      state.orderStatusDrpList = dataList;
    })
    .addCase(extraActions.GetOrderStatusDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // Payment Type List
    .addCase(extraActions.GetPaymentTypeDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetPaymentTypeDrpList.fulfilled, (state, action) => {
      state.paymentTypeDrpList = action.payload;
    })
    .addCase(extraActions.GetPaymentTypeDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // Courier Type List
    .addCase(extraActions.GetCourierTypeDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetCourierTypeDrpList.fulfilled, (state, action) => {
      // state.courierTypeDrpList = action.payload;
      state.courierTypeDrpList = action.payload.map((item) => ({
        ...item,
        IsSkipBoL: item.IsSkipBoL ?? item.IsSkipBOL ?? 0,
      }));
    })
    .addCase(extraActions.GetCourierTypeDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    })

    // Box Number List
    .addCase(extraActions.GetBoxNumberDrpList.pending, (state) => {
      state.loading = { loading: true };
    })
    .addCase(extraActions.GetBoxNumberDrpList.fulfilled, (state, action) => {
      state.boxNumberDrpList = action.payload;
    })
    .addCase(extraActions.GetBoxNumberDrpList.rejected, (state, action) => {
      state.error = { error: action.error };
    });
}
